import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {TaskStatusIds, documentTypes, HttpStatusCodes} from '../../util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function TaskDetailsReducer(state = initialState.taskDetails, action) {
	switch (action.type) {
		case types.GET_TASK_DETAILS: {
			let taskDetails = action.response;
			if (action.payload) {
				taskDetails.payload = action.payload;
			}
			let taskDetailsCopy = _.cloneDeep(taskDetails);
			let isEPSignoffUserRequiredInitialState = taskDetailsCopy.isEPSignoffUserRequired;
			let isEQRSignoffUserRequiredInitialState = taskDetailsCopy.isEQRSignoffUserRequired;

			return {
				taskStatusId: 0,
				...taskDetails,
				isEPSignoffUserRequiredInitialState: isEPSignoffUserRequiredInitialState,
				isEQRSignoffUserRequiredInitialState: isEQRSignoffUserRequiredInitialState,
				isTaskGetByIdCallComplated: state && state.resetTask ? false : true,
				description: taskDetails.description
			};
		}
		case types.GET_TASK_DETAILS_FOR_SUPER_MODAL: {
			let taskDetails = action.response;
			if (action.payload) {
				taskDetails.payload = action.payload;
			}
			let taskDetailsCopy = _.cloneDeep(taskDetails);
			let isEPSignoffUserRequiredInitialState = taskDetailsCopy.isEPSignoffUserRequired;
			let isEQRSignoffUserRequiredInitialState = taskDetailsCopy.isEQRSignoffUserRequired;

			return {
				taskStatusId: 0,
				...taskDetails,
				isEPSignoffUserRequiredInitialState: isEPSignoffUserRequiredInitialState,
				isEQRSignoffUserRequiredInitialState: isEQRSignoffUserRequiredInitialState,
				superModalTaskDetail: true
			};
		}
		case types.UPDATE_TASK_DETAILS: {
			return {
				...state,
				taskStatusId: 4
			};
		}
		case types.UPDATE_COMPLETED_TASK: {
			//Updates the status of the tasks
			if (action === undefined || !action.data) return state;
			const {statusId} = action.data;
			return {
				...state,
				taskStatusId: statusId
			};
		}

		case types.CHANGE_TASK_STATUS: {
			return {
				...state,
				taskStatusId:
					action.response && action.response.taskStatusId ? action.response.taskStatusId : state.taskStatusId
			};
		}
		case types.UPDATE_TASK_STATUS: {
			return {
				...state,
				taskStatusId: action.statusId
			};
		}
		case types.GET_TASK_DOCUMENTS:
			let taskDocumentsResponse = action.response;
			if (taskDocumentsResponse.taskStatusId) {
				let newStateTaskStatusId = {
					...state,
					taskStatusId: taskDocumentsResponse.taskStatusId
				};
				return newStateTaskStatusId;
			}

			return state;

		case types.GET_TASK_DOCUMENTS_STATUS_FLAGS_ONLY:
			let taskDocumentsStatusResponse = action.response;
			let newState = {
				...state,
				taskStatusId: taskDocumentsStatusResponse.taskStatusId,
				isEPSignoffUserRequired: taskDocumentsStatusResponse.isEPSignOffUserRequired,
				isEQRSignoffUserRequired: taskDocumentsStatusResponse.isEQRSignOffUserRequired,
				isEPEQRSignoffComplete: taskDocumentsStatusResponse.isEPEQRSignoffComplete
			};
			return newState;
		case types.RESET_TASK_DETAIL:
		case types.RESET_TASK_ATTRIBUTES:
			if (action.payloadAttributes) {
				const taskTypeId = _.get(action, 'payload.typeId');
				return {...action.payloadAttributes, taskTypeId};
			} else {
				return {
					resetTaskDetail: false
				};
			}

		case types.UPDATE_EP_SIGNOFF_USER_REQUIRED:
			let newStateEPSignOff = {
				...state,
				isEPSignoffUserRequired: action.value
			};
			return newStateEPSignOff;
		case types.UPDATE_EQR_SIGNOFF_USER_REQUIRED:
			let newStateEQRSignOff = {
				...state,
				isEQRSignoffUserRequired: action.value
			};
			return newStateEQRSignOff;
		case types.UPDATE_EP_EQR_SIGNOFF_USER_REQUIRED:
			let newStateEPEQRSignOff = {
				...state,
				isEPSignoffUserRequired: action.value.isEPSignoffUserRequired,
				isEQRSignoffUserRequired: action.value.isEQRSignoffUserRequired
			};
			return newStateEPEQRSignOff;
		case types.RESET_EP_EQR_SIGN_OFF_INFO:
			return {
				...state,
				isEPSignoffUserRequired: state.isEPSignoffUserRequiredInitialState,
				isEQRSignoffUserRequired: state.isEQRSignoffUserRequiredInitialState
			};
		case types.RESET_EP_EQR_USER_SIGNOFF_INFO_INITIAL_STATE:
			return {
				...state,
				isEPSignoffUserRequiredInitialState: state.isEPSignoffUserRequired,
				isEQRSignoffUserRequiredInitialState: state.isEQRSignoffUserRequired
			};
		case types.ASSOCIATE_TASK_DOCUMENTS: {
			if (
				(action.meta.api.data.taskIds &&
					action.meta.api.data.taskIds.length > 0 &&
					action.meta.api.data.taskIds[0] !== state.taskId) ||
				action.error
			) {
				return state;
			}
			let docTypeId = action.meta?.api?.data?.targetDocumentTypeId;
			const {InProgress: taskStatusInProgress} = TaskStatusIds;
			if (state.taskStatusId !== taskStatusInProgress && docTypeId !== documentTypes.CRASH) {
				return {
					...state,
					taskStatusId: taskStatusInProgress
				};
			}

			return state;
		}
		case types.SET_NEW_TASK_DESCRIPTION:
			return {
				...state,
				description: action.description
			};
		case types.UPDATE_TASK_MULTIENTITYTYPEID:
			if (action?.responseObj.status === HttpStatusCodes.Ok) {
				return {
					...state,
					multiEntityTypeId: action.payload[0]?.value
				};
			}

			return state;
		default:
			return state;
	}
}
